<template>
  <section class="section">
    <div class="is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <h1 class="title">Mídias</h1>
          </div>
          <h3 class="subtitle">{{ getClientName() }}</h3>
        </div>
        <div class="level-right">
          <div class="level-item">
            <b-checkbox type="is-primary" v-model="show_old"
              >Exibir Antigas</b-checkbox
            >
          </div>
          <div class="level-item">
            <b-button @click="addMidia()" icon-right="plus" type="is-primary"
              >Adicionar</b-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="card has-table">
      <div class="card-header"></div>

      <b-table
        :data="tableData"
        :paginated="true"
        :pagination-simple="true"
        :per-page="perPage"
        striped
        @page-change="onPageChange"
      >
        <template
          slot-scope="props"
          v-if="
            show_old ||
              new Date().getTime() <
                new Date(
                  new Date().setDate(
                    new Date(props.row.end_date).getDate() + 30
                  )
                )
          "
        >
          <b-table-column
            class="is-uppercase"
            field="name"
            label="Nome"
            sortable
            >{{ props.row.name }}</b-table-column
          >

          <b-table-column field="timeCreated" label="Data" sortable date>
            {{
              new Date(props.row.timeCreated).toLocaleString("pt-BR", {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                timeZone: "UTC"
              })
            }}
          </b-table-column>

          <b-table-column
            field="start_date"
            label="Período Exibição"
            sortable
            date
          >
            <span
              :class="[
                'tag',
                new Date().getTime() -
                  new Date(props.row.start_date).getTime() >=
                  0 &&
                new Date().getTime() - new Date(props.row.end_date).getTime() <=
                  0
                  ? 'is-success'
                  : 'is-light'
              ]"
              >{{ props.row.intervalo }}</span
            >
          </b-table-column>

          <b-table-column label="Ativa" field="is_active" sortable>
            <b-icon
              :icon="props.row.is_active ? 'check-circle' : 'times-circle'"
              :type="props.row.is_active ? 'is-success' : 'is-danger'"
            ></b-icon>
          </b-table-column>

          <b-table-column field="actions" label>
            <b-button
              icon-right="edit"
              size="is-small"
              type="is-light"
              @click="editItem(props.row)"
              >Editar</b-button
            >
            <b-button
              icon-right="poll-h"
              size="is-small"
              type="is-primary"
              @click="openData(props.row)"
              >Resultado</b-button
            >
            <b-button
              icon-right="trash"
              size="is-small"
              type="is-danger"
              @click="deleteItem(props.row)"
              >Excluir</b-button
            >
          </b-table-column>
          <b-modal
            has-modal-card
            trap-focus
            can-cancel
            :active.sync="dataMidia"
          >
            <div class="modal-card">
              <div class="modal-card-head">{{ mediaName }}</div>
              <div class="modal-card-body">
                <div v-if="newMedia == undefined">
                  <pyramid-chart
                    :legend="true"
                    :chart-data="pyramidData"
                    :titulo="pyramidTitle"
                    :tickRange="pyramidTick"
                    name="chartPyramid"
                  ></pyramid-chart>
                </div>

                <div v-if="newMedia">
                  <div class="box">
                    <div class="totalView">
                      <span class="totalViewTitle"
                        >Total de exibições:
                        <p style="margin-bottom: 0px;" class="totalViewNumber">
                          {{ totalViews }}
                        </p></span
                      >
                      <span class="totalViewIcon"
                        ><i class="fas fa-eye"></i
                      ></span>
                    </div>
                  </div>

                  <div style="text-align: left">
                    <div style="display: flex">
                      <div style="font-weight: bold;">Total por dia</div>
                      <div
                        style="background-color: #F2651C; height: 2px; width: 490px; margin-top: 15px; margin-left: 10px;"
                      ></div>
                    </div>

                    <apex-chart-line
                      :data="dailyMediasComp"
                      :loading="loadingDailyMedias"
                      :graphLabel="'Total Faixa Etária e Gênero'"
                    ></apex-chart-line>
                  </div>

                  <div id="cardContainer" style="text-align: left">
                    <div style="display: flex">
                      <div style="font-weight: bold;">
                        Total Faixa Etária e Gênero
                      </div>
                      <div
                        style="background-color: #F2651C; height: 2px; width: 390px; margin-top: 15px; margin-left: 10px;"
                      ></div>
                    </div>

                    <apex-chart-vertical-bar
                      :data="dailyMediasGenderAge"
                    ></apex-chart-vertical-bar>
                  </div>
                </div>
              </div>
            </div>
          </b-modal>
        </template>
        <template slot="empty">
          <section class="section">
            <div class="has-text-grey has-text-centered">
              <span>Sem mídias para exibir</span>
            </div>
          </section>
        </template>
        <template slot="footer">
          <div class="level" style="padding-bottom: 0">
            <div class="level-left"></div>
            <div class="left-center"></div>
            <div class="level-right">
              <b-select v-model="perPage" size="is-small">
                <option value="10">10 por página</option>
                <option value="25">25 por página</option>
                <option value="50">50 por página</option>
                <option value="100">100 por página</option>
              </b-select>
            </div>
          </div>
        </template>
      </b-table>
    </div>
    <b-modal
      :active.sync="dialog"
      has-modal-card
      trap-focus
      :can-cancel="false"
      aria-role="dialog"
      aria-modal
    >
      <form action>
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
            <p class="modal-card-title">{{ formTitle }}</p>
          </header>
          <section class="modal-card-body">
            <div class="columns">
              <div class="column">
                <b-field
                  type="is-primary"
                  label="Nome da Mídia"
                  label-position="on-border"
                >
                  <b-input
                    type="text"
                    v-model="editedItem.name"
                    required
                  ></b-input>
                </b-field>

                <b-field v-if="isADM">
                  <!-- <b-checkbox
                    expanded
                    v-model="editedItem.ofGroup"
                    type="is-primary"
                    >Aplicar mídia a todos os estabelecimentos do
                    grupo</b-checkbox
                  > -->
                </b-field>

                <b-field v-if="editedIndex === -1">
                  <b-upload
                    v-model="fileObj"
                    v-if="!fileObj"
                    drag-drop
                    accept="video/mp4, image/*, video/webm"
                    @input="convertImage(fileObj)"
                  >
                    <section class="section">
                      <div class="content has-text-centered">
                        <p>
                          <b-icon icon="paperclip" size="is-medium"></b-icon>
                        </p>
                        <p>Clique ou arraste seu arquivo aqui</p>
                      </div>
                    </section>
                  </b-upload>
                </b-field>
                <b-field grouped group-multiline v-else>
                  <b-field>
                    <a :href="editedItem.mediaLink" class="button is-primary"
                      >Mídia Armazenada</a
                    >
                  </b-field>
                  <b-field
                    type="is-primary"
                    v-if="isImage"
                    label="Tempo de Exibição"
                    label-position="on-border"
                  >
                    <b-input
                      v-model.number="editedItem.tempoMidia"
                      icon="hourglass-half"
                    ></b-input>
                  </b-field>
                </b-field>

                <b-field v-if="fileObj">
                  <div class="columns is-gapless">
                    <div class="column">
                      <b-tag
                        class="is-medium"
                        type="is-primary"
                        closable
                        aria-close-label="Close tag"
                        @close="fileObj = undefined"
                        >{{ fileObj.name }}</b-tag
                      >
                    </div>

                    <div
                      class="column"
                      v-if="
                        fileObj &&
                          imageName.match(/[^/]+(jpeg|jpg|png|gif|jfif|webp)$/)
                      "
                    >
                      <b-field
                        type="is-primary"
                        label="Tempo de exibição"
                        label-position="on-border"
                      >
                        <b-input
                          v-model.number="editedItem.tempoMidia"
                          icon="hourglass-half"
                        ></b-input>
                      </b-field>
                    </div>
                    <!-- <div class="column">
                      <b-field v-if="editedIndex === -1">
                        <b-button
                          type="is-info"
                          :loading="loading3"
                          :disabled="loading3"
                          class="white--text"
                          icon-right="cloud-upload-alt"
                          @click.native="uploadVideo"
                        >Upload</b-button>
                      </b-field>
                    </div> -->
                  </div>
                </b-field>

                <b-field grouped group-multiline style="margin-top: 12px">
                  <b-field
                    type="is-primary"
                    expanded
                    label="Período de Exibição"
                    label-position="on-border"
                  >
                    <b-datepicker
                      v-model="dates"
                      range
                      :mobile-native="false"
                      :date-formatter="dateConverter"
                      @input="selectDate()"
                      icon="calendar-day"
                      style="width: 240px"
                      :min-date="today"
                    >
                    </b-datepicker>
                  </b-field>
                </b-field>

                <b-field grouped group-multiline style="margin-top: 12px">
                  <b-field
                    expanded
                    label="Limite de Exibições"
                    label-position="on-border"
                    type="is-primary"
                  >
                    <b-input
                      type="text"
                      v-model.number="qtAdd"
                      icon="plus-circle"
                      icon-clickable
                      @icon-click="addQt"
                      @keyup.enter.native="addQt"
                    ></b-input>
                  </b-field>
                  <b-field
                    v-if="editedItem.showQt"
                    label="ID do cupom"
                    label-position="on-border"
                    type="is-primary"
                  >
                    <b-select v-model="editedItem.cupomFieldKey">
                      <option
                        v-for="option in getActiveFields"
                        :value="option.name"
                        :key="option.key"
                        >{{ option.name }}</option
                      >
                    </b-select>
                  </b-field>
                  <b-button
                    type="is-primary"
                    @click.native="cancelQt"
                    :disabled="
                      editedItem.showQt === undefined && editedIndex === -1
                    "
                    >Cancelar</b-button
                  >
                </b-field>

                <b-field
                  v-if="editedItem.showQt"
                  :label="
                    'Exibições: ' +
                      totalShows(editedItem.viewData) +
                      '          |            ' +
                      'Limite: ' +
                      editedItem.showQt
                  "
                  label-position="inside"
                  type="is-primary"
                >
                </b-field>

                <br />
                <b-progress
                  v-if="editedItem.showQt"
                  type="is-info"
                  :value="
                    (totalShows(editedItem.viewData) / editedItem.showQt) * 100
                  "
                ></b-progress>

                <b-field
                  label="Público Alvo - Idade"
                  label-position="inside"
                ></b-field>
                <br />
                <b-field>
                  <div class="columns">
                    <div class="column">
                      <b-input
                        disabled
                        v-model="editedItem.targetAges.ages[0]"
                      ></b-input>
                    </div>

                    <div class="column is-three-quarters">
                      <b-slider
                        size="is-large"
                        v-model="editedItem.targetAges.ages"
                        type="is-primary"
                        :min="0"
                        :max="110"
                        :step="1"
                      ></b-slider>
                    </div>

                    <div class="column">
                      <b-input
                        disabled
                        v-model="editedItem.targetAges.ages[1]"
                      ></b-input>
                    </div>
                  </div>
                </b-field>

                <b-field label="Público Alvo - Gênero" label-position="inside">
                  <br />
                </b-field>
                <b-field grouped group-multiline>
                  <b-field v-for="sex in editedItem.targetSexes" :key="sex.id">
                    <b-switch
                      type="is-primary"
                      v-model="editedItem.targetSexes[sex.id].is_active"
                      >{{ sex.label }}</b-switch
                    >
                  </b-field>
                </b-field>
                <b-field
                  label="Segmentação por Respostas a Questões"
                  label-position="inside"
                ></b-field>
                <br />
                <b-field type="is-primary" v-if="editedItem.ofGroup">
                  <b-select
                    placeholder="Questões"
                    v-model="questionSelected"
                    expanded
                    @input="changeQuestion"
                  >
                    <option
                      v-for="option in questionsDistinct"
                      :value="option"
                      :key="option.key"
                      >{{ option.text }}</option
                    >
                  </b-select>

                  <b-button
                    type="is-primary"
                    icon-right="check"
                    @click="addQuestion()"
                    >Adicionar</b-button
                  >
                </b-field>
                <b-field type="is-primary" v-else>
                  <b-select
                    placeholder="Questões"
                    v-model="questionSelected"
                    expanded
                    @input="changeQuestion"
                  >
                    <option
                      v-for="option in questions"
                      :value="option"
                      :key="option.key"
                      >{{ option.text }}</option
                    >
                  </b-select>

                  <b-button
                    type="is-primary"
                    icon-right="check"
                    @click="addQuestion()"
                    >Adicionar</b-button
                  >
                </b-field>

                <b-field grouped group-multiline position="is-desktop-centered">
                  <b-checkbox
                    v-for="resp in questionSelected.answers"
                    :key="resp.text"
                    v-model="resp.chooseAnswer"
                    type="is-primary"
                    >{{ resp.text }}</b-checkbox
                  >
                </b-field>
                <b-field>
                  <div class="columns is-multiline">
                    <div
                      class="column is-half"
                      v-for="(question,
                      questionIndex) in editedItem.targetQuestions"
                      :key="question.id"
                    >
                      <div class="card">
                        <header class="card-header">
                          <p class="card-header-title">
                            Questão {{ questionIndex + 1 }}
                          </p>

                          <a
                            @click="removeItem(question)"
                            class="card-header-icon"
                            aria-label="more options"
                          >
                            <span class="icon has-text-primary">
                              <i class="fas fa-times-circle"></i>
                            </span>
                          </a>
                        </header>
                        <div class="card-content">
                          <div class="content">
                            {{ question.text }}
                            <br />
                            <b-tag
                              v-for="resposta in question.answers.filter(
                                el => el.chooseAnswer
                              )"
                              :key="resposta.text"
                              type="is-primary"
                              closable
                              @close="removeAnswer(resposta, question)"
                              >{{ resposta.text }}</b-tag
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-field>
                <br />
                <b-field
                  label="Dias e horários de exibição"
                  label-position="inside"
                ></b-field>
                <br />
                <b-field grouped group-multiline>
                  <b-checkbox
                    expanded
                    v-for="(day, index) in weekdays"
                    :key="day"
                    v-model="editedItem.days"
                    :native-value="index"
                    type="is-primary"
                    >{{ day }}</b-checkbox
                  >
                </b-field>
                <b-field style="margin-top: 12px">
                  <b-field
                    label="Horários inicial e final"
                    label-position="inside"
                  ></b-field>
                </b-field>
                <br />

                <b-field grouped group-multiline>
                  <b-field type="is-primary">
                    <b-select label="Início" v-model="startHour">
                      <option
                        v-for="option in hours"
                        :value="option"
                        :key="option"
                        >{{ option }}</option
                      >
                    </b-select>
                    <b-select placeholder="Fim" v-model="endHour">
                      <option
                        v-for="option in hours"
                        :value="option"
                        :key="option"
                        >{{ option }}</option
                      >
                    </b-select>
                    <b-button
                      type="is-primary"
                      icon-right="plus-circle"
                      @click="addHourRange(startHour + '-' + endHour)"
                    ></b-button>
                  </b-field>

                  <b-field
                    grouped
                    group-multiline
                    v-for="(tag, index) in editedItem.hourRanges"
                    :key="index"
                  >
                    <b-tag
                      size="is-medium"
                      type="is-primary"
                      closable
                      @close="removeHourRange(tag)"
                      >{{ tag }}</b-tag
                    >
                  </b-field>
                </b-field>

                <b-field>
                  <b-checkbox type="is-primary" v-model="editedItem.is_active"
                    >Ativo</b-checkbox
                  >
                </b-field>
                <!-- <b-field>
                  <b-checkbox
                    type="is-primary"
                    v-model="editedItem.show_on_dashboard"
                    >Mostrar no Dashboard</b-checkbox
                  >
                </b-field> -->
              </div>
              <div
                class="column is-one-quarter"
                v-if="
                  (editedIndex != -1 || (!!fileObj && !!imageUrl)) && isImage
                "
              >
                <b-field label="Preview" label-position="on-border">
                  <b-select v-model="device" @input="selectDevice">
                    <option
                      v-for="(option, index) in devices"
                      :value="option"
                      :key="index"
                      >{{ option.text }}</option
                    >
                  </b-select>
                </b-field>

                <b-field>
                  <div ref="divPhone" class="preview">
                    <div ref="toolbarPhone" class="toolbar-phone"></div>
                    <div ref="phoneViewport" class="viewport-phone"></div>
                  </div>
                </b-field>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot">
            <b-button @click="close" :loading="saving">Cancelar</b-button>
            <b-button
              type="is-primary"
              @click.native="save"
              :loading="saving"
              :disabled="
                (!videoUploaded && editedIndex === -1) || !dateSelected
              "
              >Salvar</b-button
            >
            <b-button
              type="is-primary"
              v-if="isADM && editedItem.ofGroup"
              :disabled="
                (!videoUploaded && editedIndex === -1) || !dateSelected
              "
              @click.native="saveGrupo"
              :loading="saving"
              >Salvar no Grupo</b-button
            >
          </footer>
        </div>
      </form>
    </b-modal>
  </section>
</template>

<script>
import Webservices from "@/Webservices";
import Pie from "@/components/charts/Pie";
import Bar from "@/components/charts/Bar";
import Linechart from "@/components/charts/Linechart";
import OnlineLine from "@/components/charts/OnlineLine";
import BoxStat from "@/components/charts/BoxStat";
import HorizontalBar from "@/components/charts/HorizontalBar.vue";
import ApexChartVerticalBar from "@/components/charts/ApexChartVerticalBar";
import PyramidChart from "@/components/charts/PyramidChart.vue";
import ChartMin from "@/components/charts/ChartMin.vue";
import ApexChartLine from "@/components/charts/ApexChartLine";
import store from "@/store";
import { mapActions, mapGetters } from "vuex";

const ws = new Webservices();
var moment = require("moment");

export default {
  components: {
    Pie,
    Bar,
    ApexChartLine,
    ApexChartVerticalBar,
    BoxStat,
    Linechart,
    PyramidChart
  },
  name: "Videos",
  data: () => ({
    show_old: false,
    dataMidia: false,
    saving: false,
    perPage: 10,
    fileObj: undefined,
    weekdays: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
    device: {
      text: "iPhone 5/6/7",
      value: "iphone567",
      width: 640,
      height: 1136,
      toolbarHeight: 163
    },
    newMedia: false,
    mediaName: "",
    dates: [],
    startDate: moment()
      .subtract(7, "days")
      .format(),

    endDate: moment().format(),

    totalViews: 0,
    today: new Date(moment().subtract(1, "days")),
    dateSelected: false,
    devices: [
      {
        text: "iPhone 5/6/7",
        value: "iphone567",
        width: 640,
        height: 1136,
        toolbarHeight: 163
      },
      {
        text: "iPhone X/XS",
        value: "iphoneX",
        width: 1125,
        height: 2436,
        toolbarHeight: 0
      },
      {
        text: "iPhone 8",
        value: "iphone8",
        width: 750,
        height: 1334,
        toolbarHeight: 0
      },
      {
        text: "iPhone XR",
        value: "iphoneXR",
        width: 828,
        height: 1792,
        toolbarHeight: 0
      },
      {
        text: "iPhone 6/7/8 Plus",
        value: "iphone678Plus",
        width: 1080,
        height: 1920,
        toolbarHeight: 0
      },
      {
        text: "iPhone 4S",
        value: "iphone4s",
        width: 640,
        height: 960,
        toolbarHeight: 0
      },
      {
        text: "Samsung Galaxy J7",
        value: "samsungJ7",
        width: 720,
        height: 1280,
        toolbarHeight: 0
      },
      {
        text: "Samsung Galaxy S6",
        value: "samsungS6",
        width: 1440,
        height: 2560,
        toolbarHeight: 0
      },
      {
        text: "Samsung Galaxy S8",
        value: "iphoneX",
        width: 1440,
        height: 2960,
        toolbarHeight: 0
      },
      {
        text: "LG G3/G4/V10",
        value: "lgG3",
        width: 1440,
        height: 2560,
        toolbarHeight: 0
      },
      {
        text: "LG Nexus 4/4R",
        value: "lgNexus4",
        width: 768,
        height: 1280,
        toolbarHeight: 0
      },
      {
        text: "LG Nexus 5X",
        value: "lgNexus5X",
        width: 1080,
        height: 1920,
        toolbarHeight: 0
      },
      {
        text: "Motorola Moto G",
        value: "motoG",
        width: 720,
        height: 1280,
        toolbarHeight: 0
      },
      {
        text: "Motorola Moto X/Z",
        value: "motoXZ",
        width: 1440,
        height: 2560,
        toolbarHeight: 0
      },
      {
        text: "Motorola Moto E",
        value: "iphoneX",
        width: 540,
        height: 960,
        toolbarHeight: 0
      },
      {
        text: "Samsung Galaxy Note",
        value: "samsungGalaxyNote",
        width: 800,
        height: 1280,
        toolbarHeight: 0
      },
      {
        text: "Samsung Galaxy Note II",
        value: "samsungGalaxyNote2",
        width: 720,
        height: 1280,
        toolbarHeight: 0
      },
      {
        text: "Samsung Galaxy Note 4/5",
        value: "samsungGalaxyNote45",
        width: 1440,
        height: 2560,
        toolbarHeight: 0
      }
    ],
    qtAdd: undefined,
    questions: [],
    questionsDistinct: [],
    questionSelected: {},
    videoUploaded: false,
    loadingDailyMedias: false,
    dailyMedias: {
      total: [],
      dates: []
    },
    dailyMediasGenderAge: {},
    dateSD: "",
    dateED: "",
    modalSD: false,
    modalED: false,
    loading3: false,
    modal: false,
    imageName: "",
    imageUrl: "",
    imageFile: "",
    dialog: false,
    hours: [
      "00:00",
      "01:00",
      "02:00",
      "03:00",
      "04:00",
      "05:00",
      "06:00",
      "07:00",
      "08:00",
      "09:00",
      "10:00",
      "11:00",
      "12:00",
      "13:00",
      "14:00",
      "15:00",
      "16:00",
      "17:00",
      "18:00",
      "19:00",
      "20:00",
      "21:00",
      "22:00",
      "23:00",
      "23:59"
    ],

    startHour: "00:00",
    endHour: "23:59",
    desserts: [],
    editedIndex: -1,
    editedItem: {
      ofGroup: false,
      cupomFieldKey: undefined,
      tempoMidia: 10,
      client_id: "",
      newMedia: false,
      author: "",
      name: "",
      bucket: "",
      timeCreated: undefined,
      size: 0,
      mediaLink: undefined,
      start_date: null,
      end_date: null,
      is_active: true,
      show_on_dashboard: true,
      targetQuestions: [],
      type: "",
      targetAges: { ages: [0, 110] },
      targetSexes: [
        {
          id: 0,
          label: "Masculino",
          value: "m",
          is_active: true
        },
        {
          id: 1,
          label: "Feminino",
          value: "f",
          is_active: true
        },
        {
          id: 2,
          label: "Não informado",
          value: "",
          is_active: true
        }
      ],
      showQt: undefined,
      viewData: [
        {
          id: 0,
          label: "0 a 14",
          data: [0, 0, 0],
          value: [0, 14]
        },
        {
          id: 1,
          label: "15 a 20",
          data: [0, 0, 0],
          value: [15, 20]
        },
        {
          id: 2,
          label: "21 a 30",
          data: [0, 0, 0],
          value: [21, 30]
        },
        {
          id: 3,
          label: "31 a 40",
          data: [0, 0, 0],
          value: [31, 40]
        },
        {
          id: 4,
          label: "41 a 50",
          data: [0, 0, 0],
          value: [41, 50]
        },
        {
          id: 5,
          label: "51 a 60",
          data: [0, 0, 0],
          value: [51, 60]
        },
        {
          id: 6,
          label: "61 ou mais",
          data: [0, 0, 0],
          value: [61, 110]
        },
        {
          id: 7,
          label: "Não informado",
          data: [0, 0, 0]
        }
      ],
      days: ["0", "1", "2", "3", "4", "5", "6"],
      hourRanges: ["00:00-23:59"]
    },
    defaultItem: {
      ofGroup: false,
      cupomFieldKey: undefined,
      tempoMidia: 10,
      client_id: "",
      author: "",
      name: "",
      bucket: "",
      timeCreated: undefined,
      size: 0,
      mediaLink: undefined,
      start_date: null,
      end_date: null,
      is_active: true,
      show_on_dashboard: true,
      type: "",
      targetQuestions: [],
      targetAges: { ages: [0, 110] },
      targetSexes: [
        {
          id: 0,
          label: "Masculino",
          value: "m",
          is_active: true
        },
        {
          id: 1,
          label: "Feminino",
          value: "f",
          is_active: true
        },
        {
          id: 2,
          label: "Não informado",
          value: "",
          is_active: true
        }
      ],
      showQt: undefined,
      viewData: [
        {
          id: 0,
          label: "0 a 14",
          data: [0, 0, 0],
          value: [0, 14]
        },
        {
          id: 1,
          label: "15 a 20",
          data: [0, 0, 0],
          value: [15, 20]
        },
        {
          id: 2,
          label: "21 a 30",
          data: [0, 0, 0],
          value: [21, 30]
        },
        {
          id: 3,
          label: "31 a 40",
          data: [0, 0, 0],
          value: [31, 40]
        },
        {
          id: 4,
          label: "41 a 50",
          data: [0, 0, 0],
          value: [41, 50]
        },
        {
          id: 5,
          label: "51 a 60",
          data: [0, 0, 0],
          value: [51, 60]
        },
        {
          id: 6,
          label: "61 ou mais",
          data: [0, 0, 0],
          value: [61, 110]
        },
        {
          id: 7,
          label: "Não informado",
          data: [0, 0, 0]
        }
      ],
      days: ["0", "1", "2", "3", "4", "5", "6"],
      hourRanges: ["00:00-23:59"]
    }
  }),
  computed: {
    ...mapGetters([
      "ageRanges",
      "getClientID",
      "getName",
      "getID",
      "getRules",
      "isADM",
      "getGroupId",
      "getClients",
      "getToken"
    ]),
    dailyMediasComp() {
      var output = {
        total: this.dailyMedias.total,
        dates: this.dailyMedias.dates
      };

      return output;
    },
    tableData() {
      var output = this.desserts;

      return output;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Nova Mídia" : "Editar";
    },
    isImage() {
      return /[^/]+(jpeg|jpg|png|gif|jfif|webp)$/.test(this.imageName);
    },
    getActiveFields() {
      return this.client_fields.filter(el => el.is_active);
    }
  },

  async mounted() {
    ws.setToken(this.getToken);
    if (await ws.checkAccessToken(this.getToken)) {
      this.logout();
      this.$router.push("/login");
    }

    this.pyramidTitle = "";
    this.pyramidData = [];
    this.pyramidTick = 0;
    document.addEventListener("openMidia", evt => {});
    if (this.getID) {
      ws.getClientFields(this.getID).then(response => {
        this.client_fields = response.data.fields;
      });

      ws.getVideos(this.getClientID).then(response => {
        this.desserts = response.data.map(el => ({
          ...el,
          intervalo:
            new Date(el.start_date).toLocaleDateString("pt-BR", {
              year: "numeric",
              month: "numeric",
              day: "numeric",
              timeZone: "UTC"
            }) +
            " - " +
            new Date(el.end_date).toLocaleString("pt-BR", {
              year: "numeric",
              month: "numeric",
              day: "numeric",
              timeZone: "UTC"
            })
        }));
      });
    } else {
      ws.getVideosByGroup(this.getGroupId).then(response => {
        response.data.forEach(video => {
          video["intervalo"] =
            new Date(el.start_date).toLocaleDateString("pt-BR", {
              year: "numeric",
              month: "numeric",
              day: "numeric",
              timeZone: "UTC"
            }) +
            " - " +
            new Date(el.end_date).toLocaleString("pt-BR", {
              year: "numeric",
              month: "numeric",
              day: "numeric",
              timeZone: "UTC"
            });
          if (
            !this.desserts.find(el => el.video_group_id == video.video_group_id)
          )
            this.desserts.push(video);
        });
      });
    }

    if (this.isADM) {
      if (this.getID) {
        ws.getQuestions(this.getClientID).then(response => {
          this.questions = response.data;
          this.questionsDistinct = response.data.filter(el => el.ofGroup);
        });
      } else {
        ws.getQuestionsByGroup(this.getGroupId).then(response => {
          response.data.forEach(question => {
            if (
              !this.questionsDistinct.find(
                el => el.question_group_id === question.question_group_id
              )
            )
              this.questionsDistinct.push(question);
          });
        });
      }
    } else {
      ws.getQuestions(this.getClientID).then(response => {
        this.questions = response.data.map(el => !el.ofGroup);
      });
    }
  },

  watch: {
    dataMidia(val) {
      if (val) {
        store.state.currentModal = "resultMidiaModal";
      } else {
        store.state.currentModal = undefined;
      }
    },
    dialog(val) {
      if (val) {
        store.state.currentModal = "addOrEditMidiaModal";
      } else {
        store.state.currentModal = undefined;
        this.close();
      }
    },
    getClientID(newValue) {
      this.client_fields = [];
      this.desserts = [];
      this.questions = [];

      ws.getClientFields(this.getID).then(response => {
        this.client_fields = response.data.fields;
      });

      ws.getVideos(newValue).then(response => {
        this.desserts = response.data.map(el => ({
          ...el,
          intervalo:
            new Date(el.start_date).toLocaleDateString("pt-BR", {
              year: "numeric",
              month: "numeric",
              day: "numeric",
              timeZone: "UTC"
            }) +
            " - " +
            new Date(el.end_date).toLocaleString("pt-BR", {
              year: "numeric",
              month: "numeric",
              day: "numeric",
              timeZone: "UTC"
            })
        }));
      });
      ws.getQuestions(newValue).then(response => {
        this.questions = response.data;
      });
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions(["logout"]),
    initialize() {},
    dateConverter(date) {
      if (date[0]) {
        return (
          date[0].toLocaleString("pt-BR", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            timeZone: "UTC"
          }) +
          " - " +
          date[1].toLocaleString("pt-BR", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            timeZone: "UTC"
          })
        );
      }
    },
    onPageChange(page) {
      this.page = page;
      this.loadAsyncData();
    },
    selectDate() {
      this.editedItem.start_date = moment(this.dates[0]);
      this.editedItem.end_date = moment(this.dates[1]);
      this.dateSelected = true;
    },
    async saveGrupo() {
      this.dates = [];
      this.saving = true;

      this.editedItem["author"] = this.getName;
      this.editedItem["group_id"] = this.getGroupId;

      if (!!this.editedItem["video_group_id"]) {
        var response = await ws.updateVideoManifestGroup(this.editedItem);
      } else {
        var videoGroupId = `${this.getGroupId}_${new Date().toISOString()}`;

        for (var i = 0; i < this.getClients.length; i++) {
          const el = this.getClients[i];

          var questionTargets = [];

          this.editedItem.targetQuestions.forEach(tq => {
            var question = this.questions.find(
              q =>
                q.question_group_id == tq.question_group_id &&
                q.client_id == el.client_id
            );

            if (question) questionTargets.push(question);
          });

          var item = Object.assign({}, this.editedItem);

          if (Object.keys(questionsTarget[0].length === 0)) {
            item["targetQuestions"] = [];
          } else {
            item["targetQuestions"] = questionTargets;
          }
          item["client_id"] = el.controller_id;
          item["video_group_id"] = videoGroupId;

          var response = await ws.saveVideoManifest(item);

          if (!this.getID && i == 0) this.desserts.push(response.data);
          else if (response.data.client_id == this.getClientID)
            this.desserts.push(response.data);
        }
      }

      this.saving = false;

      this.close();
    },
    getClientName() {
      return store.state.client.name;
    },

    selectDevice() {
      var divPhone = this.$refs.divPhone;
      var toolbarPhone = this.$refs.toolbarPhone;
      var phoneViewport = this.$refs.phoneViewport;

      var dimShow = {
        width: 160,
        height: Math.round(this.device.height * (160 / this.device.width)),
        toolbarHeight: Math.round(
          this.device.toolbarHeight * (160 / this.device.width)
        )
      };

      divPhone.style = "height: " + dimShow.height + "px;";

      phoneViewport.style =
        "height: " +
        dimShow.height +
        "px; top:" +
        Math.round(dimShow.toolbarHeight / 2) +
        "px;background-position: center; background-repeat: no-repeat; background-size: contain; background-image: url('" +
        this.imageUrl +
        "');";

      toolbarPhone.style = "height: " + dimShow.toolbarHeight + "px;";

      this.$forceUpdate();
    },

    changedQuestion(i) {
      if (
        !this.editedItem.targetQuestions[i + 1] &&
        this.editedItem.targetQuestions[i].hasOwnProperty("question")
      ) {
        this.editedItem.targetQuestions.push({ index: i + 1 });
      }
    },
    deleteQuestion(i) {
      this.editedItem.targetQuestions.splice(i, 1);
    },
    openData(item) {
      this.mediaName = item.name;

      this.newMedia = item.newMedia;

      if (this.newMedia == undefined) {
        var backgroundColor = [
          "rgb(92,154,239, 0.8)",
          "rgba(71,192,235, 0.8)",
          "rgba(255,207,71, 0.8)",
          "rgba(63,207,172, 0.8)",
          "rgba(159,214,97, 0.8)",
          "rgba(253,109,75, 0.8)",
          "rgba(240,84,98, 0.8)"
        ];
        var borderColor = [
          "rgb(71,135,223)",
          "rgb(49,174,220)",
          "rgb(247,188,48)",
          "rgb(45,189,154)",
          "rgb(140,194,75)",
          "rgb(235,86,56)",
          "rgb(240,84,98)"
        ];
        var saidaModel = {
          dialog: false,
          title: "",
          visibility: true,
          tick: 0,
          data: {
            labels: [],
            datasets: [
              {
                label: "Masculino",
                backgroundColor: backgroundColor[0],
                borderColor: borderColor[0],
                borderWidth: 1,
                data: []
              },
              {
                label: "Feminino",
                backgroundColor: backgroundColor[1],
                borderColor: borderColor[1],
                borderWidth: 1,
                data: []
              }
            ]
          }
        };
        var saidaArray = [];
        ws.getVideo(item.id).then(response => {
          var saida = {};
          var video = response.data;
          saida = JSON.parse(JSON.stringify(saidaModel));
          saida.title = video.name;
          saida.visibility = true;
          video.viewData.forEach(el => {
            saida.data.labels.push(el.label);
            saida.data.datasets[0].data[el.id] = -el.data[0];
            saida.data.datasets[1].data[el.id] = el.data[1];
            if (el.data[0] > saida.tick) {
              saida.tick = el.data[0];
            }
            if (el.data[1] > saida.tick) {
              saida.tick = el.data[1];
            }
          });
          saidaArray.push(JSON.parse(JSON.stringify(saida)));
          this.pyramidTitle = saidaArray[0].title;
          this.pyramidData = saidaArray[0].data;
          this.pyramidTick = saidaArray[0].tick;
          this.dataMidia = true;
        });
      } else {
        let totals = [];
        let dates = [];

        this.loadingDailyMedias = true;
        var newReportDateReference = new Date("2023-05-05T03:00:00.000Z");
        if (item.start_date < newReportDateReference) {
          this.startDate = newReportDateReference;
        } else {
          console.log(item.startDate);
          this.startDate = moment(item.start_date).format();
        }
        // this.endDate = new Date(item.end_date);
        // this.endDate.setDate(this.endDate.getDate() - 1)

        ws.getTotalMediaCount(item.id).then(response => {
          this.totalViews = response.data.total;
        });

        ws.getDailyMediaReport(item.id, this.startDate, this.endDate).then(
          response => {
            response.data.forEach(item => {
              const viewData = item.viewData;
              const totalData = viewData.reduce((total, view) => {
                const sumData = view.data.reduce(
                  (sum, value) => sum + value,
                  0
                );
                return total + sumData;
              }, 0);

              totals.push(totalData);
              dates.push(moment(item.datetime).format("DD/MM/YYYY"));

              this.dailyMedias = {
                total: totals,
                dates: dates
              };

              this.loadingDailyMedias = false;
            });

            const labels = [
              "0 a 14",
              "15 a 20",
              "21 a 30",
              "31 a 40",
              "41 a 50",
              "51 a 60",
              "61 ou mais",
              "Não informado"
            ];
            const datasets = [
              { label: "Masculino", data: Array(labels.length).fill(0) },
              { label: "Feminino", data: Array(labels.length).fill(0) },
              { label: "Não Informado", data: Array(labels.length).fill(0) }
            ];

            response.data.forEach(item => {
              const viewData = item.viewData;

              viewData.forEach(view => {
                const ageGroup = view.ageGroup;
                const data = view.data;

                const maleTotal = data[0];
                const femaleTotal = data[1];
                const otherTotal = data[2];

                const ageGroupIndex = labels.indexOf(ageGroup);

                if (ageGroupIndex !== -1) {
                  datasets[0].data[ageGroupIndex] += maleTotal;
                  datasets[1].data[ageGroupIndex] += femaleTotal;
                  datasets[2].data[ageGroupIndex] += otherTotal;
                }
              });
            });

            let obj = {
              labels: labels,
              datasets: datasets
            };

            this.dailyMediasGenderAge = obj;

            this.dataMidia = true;
          }
        );
      }
    },

    async editItem(item) {
      if (item.type.split("/")[0] == "image") {
        var imgData = await fetch(item.videoLink, {
          headers: {
            Authorization: this.getToken
          }
        });

        var imgBlob = await imgData.blob();
        const fr = new FileReader();

        const self = this;

        fr.addEventListener("load", function() {
          self.imageUrl = this.result;
          self.selectDevice();
        });
        fr.readAsDataURL(imgBlob);
      }

      this.imageName = item.originalFilename;
      this.editedItem = item;
      this.editedIndex = this.desserts.indexOf(item);

      if (!this.editedItem.targetAges.hasOwnProperty("ages")) {
        this.editedItem.targetAges.ages = [0, 110];
      }

      if (
        !this.editedItem.hasOwnProperty("ofGroup") &&
        !this.editedItem.hasOwnProperty("group_id")
      ) {
        this.editedItem["ofGroup"] = false;
      } else if (this.editedItem.hasOwnProperty("group_id")) {
        this.editedItem["ofGroup"] = true;
      }

      if (!this.editedItem.hasOwnProperty("days")) {
        this.editedItem.days = this.defaultItem.days.slice(0);
      }
      if (!this.editedItem.hasOwnProperty("hourRanges")) {
        this.editedItem.hourRanges = this.defaultItem.hourRanges.slice(0);
      }
      this.dates[0] = new Date(this.editedItem.start_date);
      this.dates[1] = new Date(this.editedItem.end_date);
      this.selectDate();
      this.editedItem.start_date = new Date(this.editedItem.start_date);
      this.editedItem.end_date = new Date(this.editedItem.end_date);

      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      if (confirm("Você tem certeza que deseja remover essa mídia?")) {
        this.desserts.splice(index, 1);
        ws.deleteVideoManifest(item.id).then(response => {});
      }
    },

    close() {
      this.dates = [];
      this.dialog = false;
      this.editedItem = this.defaultItem;
      setTimeout(() => {
        this.resetForm();
      }, 300);
    },

    save() {
      this.dates = [];
      this.editedItem["author"] = this.getName;
      this.editedItem["client_id"] = this.getClientID;
      this.editedItem.newMedia = true;
      if (this.editedItem.targetQuestions.length == 1) {
        if (this.editedItem.targetQuestions[0] == "{}")
          this.editedItem.targetQuestions = [];
      }
      if (this.editedIndex > -1) {
        ws.updateVideoManifest(this.editedItem).then(response => {
          //console.log("save and close");
          this.desserts[this.editedIndex] = response.data;
          this.close();
        });
      } else {
        ws.saveVideoManifest(this.editedItem).then(response => {
          //console.log("save and close");
          this.desserts.push(response.data);
          this.close();
        });
      }
    },

    pickFile() {
      this.$refs.file.click();
    },
    convertImage(file) {
      if (
        file.type == "video/mp4" ||
        file.type == "video/webm" ||
        file.type == "image/gif"
      ) {
        this.onFilePicked(file);
      } else {
        let rawImage = new Image();

        rawImage.src = URL.createObjectURL(file);

        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");

        rawImage.onload = () => {
          canvas.width = rawImage.width;
          canvas.height = rawImage.height;
          ctx.drawImage(rawImage, 0, 0);
          canvas.toBlob(
            blob => {
              this.onFilePicked(blob);
            },
            "image/webp",
            0.2
          );
        };
      }
    },

    onFilePicked(file) {
      this.imageName = this.fileObj.name;
      if (this.imageName.lastIndexOf(".") <= 0) {
        return;
      }

      const fr = new FileReader();
      if (this.fileObj.type !== "video/mp4" && file.type !== "video/webm") {
        this.fileObj = file;
      }
      fr.readAsDataURL(file);
      setTimeout(() => {
        this.uploadVideo();
      }, 500);
      fr.addEventListener("load", () => {
        this.imageUrl = fr.result;
        this.imageFile = file; // this is an image file that can be sent to server...
        setTimeout(_ => {
          if (this.isImage) this.selectDevice();
        }, 500);
      });
    },

    uploadVideo() {
      this.loading3 = true;

      var formData = new FormData();
      formData.append("file", this.fileObj);
      //console.log("formData ", formData)
      ws.uploadVideo(formData).then(response => {
        //console.log("response ", response)
        var videoManifest = response.data.result.files.file[0];

        this.editedItem.size = videoManifest.size;
        this.editedItem.type = videoManifest.type;
        this.editedItem.bucket = videoManifest.providerResponse.bucket;
        this.editedItem.selfLink = videoManifest.providerResponse.selfLink;
        this.editedItem.timeCreated =
          videoManifest.providerResponse.timeCreated;
        this.editedItem.uniqueName = videoManifest.name;
        this.editedItem.originalFilename = videoManifest.originalFilename;
        this.editedItem.name = videoManifest.originalFilename;
        this.editedItem.mediaLink_bkp =
          videoManifest.providerResponse.mediaLink;

        this.editedItem.videoLink =
          ws.getUrl() +
          "/videos/" +
          this.editedItem.bucket +
          "/download/" +
          this.editedItem.uniqueName;

        //https://www.googleapis.com/download/storage/v1/b/noos-videos/o/a90f96f6-8433-4769-afd0-71f0eb5a9dd8.jpg?generation=1636144430546827&alt=media"
        //"https://storage.googleapis.com/noos-videos/72aa6e5b-8118-4c1e-9b91-35a2250036c1.jpg?generation=1636118399767636&alt=media"
        this.editedItem.mediaLink =
          "https://midia.vagalumewifi.com.br/" +
          this.editedItem.uniqueName +
          "?" +
          this.editedItem.mediaLink_bkp.split("?")[1];

        this.videoUploaded = true;

        this.loading3 = false;
      });
    },
    resetForm() {
      this.imageName = "";
      this.fileObj = undefined;
      this.loading3 = false;
      this.dates = [];
      this.videoUploaded = false;
    },
    addQuestion() {
      if (!this.editedItem.hasOwnProperty("targetQuestions"))
        this.editedItem["targetQuestions"] = [];
      if (
        this.editedItem.targetQuestions.indexOf(this.questionSelected) == -1
      ) {
        var question = JSON.parse(JSON.stringify(this.questionSelected));
        question["question_id"] = question.id;
        delete question["id"];
        this.editedItem.targetQuestions.push(question);
      }

      this.questionSelected = {};

      this.$forceUpdate();
    },
    changeQuestion($evt) {
      $evt.answers.forEach(answer => {
        if (!answer.hasOwnProperty("chooseAnswer"))
          answer["chooseAnswer"] = false;
      });
    },
    removeItem(item) {
      this.editedItem.targetQuestions.splice(
        this.editedItem.targetQuestions.indexOf(item),
        1
      );
      this.$forceUpdate();
    },

    removeAnswer(resposta, question) {
      question.answers.splice(question.answers.indexOf(resposta), 1);
      this.$forceUpdate();
    },
    addQt() {
      if (!!this.qtAdd) {
        if (this.editedItem.showQt == undefined) this.editedItem.showQt = 0;

        this.editedItem.showQt += this.qtAdd;

        this.qtAdd = undefined;
      }
    },
    cancelQt() {
      if (!!this.qtAdd) {
        this.qtAdd = undefined;
      }
      if (this.editedItem.showQt > 0) this.editedItem.showQt = undefined;
    },
    totalShows(viewData) {
      var saida = 0;
      viewData.forEach(vd => {
        saida += vd.data.reduce((acc, curr) => acc + curr);
      });

      return saida;
    },
    removeHourRange(item) {
      this.editedItem.hourRanges.splice(
        this.editedItem.hourRanges.indexOf(item),
        1
      );
    },
    addHourRange(item) {
      this.editedItem.hourRanges.push(item);
    },
    addMidia() {
      this.dialog = true;
      //TODO adicionar data default para criacao de midia
      // this.dateED = moment()
      // .add(6, "d")
      // .format("YYYY-MM-DD");

      // this.dateSD = moment().format("YYYY-MM-DD");
      this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
      this.editedIndex = -1;
    }
  }
};
</script>

<style scoped>
.capitalize {
  text-transform: capitalize !important;
}
.preview {
  position: relative;
  width: 160px;
  padding: 0;
  border: thin solid blue;
  background-color: lightgray;
  z-index: 1;
  overflow-y: hidden;
}

.toolbar-phone {
  position: absolute;
  width: 160px;
  top: 0;
  left: 0;
  border: thin solid blue;
  background-color: whitesmoke;
  z-index: 3;
  opacity: 0.88;
}

.viewport-phone {
  position: absolute;
  width: 160px;
  left: 0;
  background-color: lightgray;
  z-index: 2;
}

.totalView {
  display: flex;
  justify-content: space-between;
}

.totalViewTitle {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: -10px;
}

.totalViewNumber {
  margin-right: 70px;
  font-size: 30px;
  font-weight: bold;
}

.totalViewIcon {
  width: 60px;
  height: 60px;
  padding-top: 16px;
  color: white;
  border-radius: 5px;
  font-size: 18px;
  background-color: #f2651c;
}

#cardContainer {
  height: 350px;
}
</style>



// WEBPACK FOOTER //
// src/components/Videos.vue